import React, { Component } from 'react'
import styled from 'styled-components'
import { Row, Col } from 'styled-bootstrap-grid'
import withMaterials from 'containers/withMaterials'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

class Results extends Component {
  static defaultProps = {
    category: null,
    product: null
  }

  getMimeType(mime) {
    return mime.split("/").pop()
  }
  
  render() {
    const materials = this.props.materials ? this.props.materials.nodes : []
    
    return(
      <Row>
        {materials.map(material => (
          <StyledCol sm={6} lg={4} key={material.id}>
            <Material>
              <Meta>
                <Label>{material.label}</Label>
                <Mime>{this.getMimeType(material.file.mimeType)}</Mime>
              </Meta>
              <h2>{material.title || material.file.mediaDetails.file}</h2>
              <Thumb image={material.thumbnail.sourceUrl}>
                <ButtonContainer>
                  <Button href={material.file.sourceUrl} target="_blank" download>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                    >
                      <path
                        fill="none"
                        fillRule="evenodd"
                        stroke="#004178"
                        d="M15 6l-7 7-7-7m7 7V0M1 17h14"
                      ></path>
                    </svg>
                  </Button>
                  <Button href={material.file.sourceUrl} target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="22"
                      viewBox="0 0 21 22"
                    >
                      <g fill="none" fillRule="evenodd" stroke="#004178">
                        <path d="M1.095 8.76l.103-7.746 7.745.169M1.411.985L8.48 8.304M19.83 13.18l.032 7.747-7.746-.033m7.534.066l-7.195-7.194"></path>
                      </g>
                    </svg>
                  </Button>
                </ButtonContainer>
              </Thumb>
            </Material>
          </StyledCol>

        ))}
      </Row>
    )
  }
}

export default withMaterials(
  props => ({
    category: props.category,
    product: props.product
  })
)(Results)

// Styles
const { colors } = theme

const StyledCol = styled(Col)`
  margin-bottom: 2rem;
`

const Material = styled.div`
  background: ${colors.tones.lightest};
  padding: 1.5rem 1.5rem 0 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 1rem;
    line-height: normal;
    flex-grow: 1;
  }
`

const Meta = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    color: ${colors.primary};
  }
`

const Label = styled.p`
  flex-grow: 1;
  font-size: 0.75rem;
`

const Mime = styled.p`
  font-size: 0.65rem;
  text-transform: uppercase;
  border: 1px solid ${colors.primary};
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
`

const Thumb = styled.div`
  height: 0;
  width: 100%;
  padding-bottom: 56.25%;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  align-self: flex-end;
  position: relative;
`

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  display: flex;
`

const Button = styled.a`
  background: white;
  border-radius: 100%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
  transition: background-color 0.3s ${easing.easeOutCubic};

  svg {
    g, path {
      transition: stroke 0.3s ${easing.easeOutCubic};
    }
  }

  &:hover {
    background-color: ${colors.primary};

    svg {
      g, path {
        stroke: white;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/PressMaterials/Results.js